export default "__VITE_ASSET__c23bb615__"